var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01Blue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56.4019,
    height: 56.4019,
    rx: 28.2009,
    fill: "#2A71FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6109 37.6015C21.4076 37.6015 19.7301 36.8003 18.5784 35.1979C17.4267 33.5955 16.8508 31.2921 16.8508 28.2876C16.8508 25.2831 17.4267 22.9797 18.5784 21.3773C19.7301 19.7749 21.4076 18.9737 23.6109 18.9737C25.8142 18.9737 27.4917 19.7749 28.6434 21.3773C29.7952 22.9797 30.371 25.2831 30.371 28.2876C30.371 31.3171 29.7952 33.6206 28.6434 35.223C27.4917 36.8254 25.8142 37.6015 23.6109 37.6015ZM23.6109 35.273C26.2649 35.273 27.5919 32.9446 27.5919 28.2876C27.5919 23.6307 26.2649 21.3022 23.6109 21.3022C20.957 21.3022 19.655 23.6307 19.655 28.2876C19.655 32.9446 20.957 35.273 23.6109 35.273ZM36.9926 19.3743H39.1458V37.2009H36.4668V24.4819H32.3857V22.504L32.7863 22.4789C34.0632 22.4038 35.0147 22.1284 35.6656 21.6777C36.3166 21.2271 36.7423 20.4509 36.9926 19.3743Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01Blue);
export default __webpack_public_path__ + "static/media/01-blue.a89801366fb2fc58e3c7f99493f6d62f.svg";
export { ForwardRef as ReactComponent };